<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'DefectParetoChart',
  extends: Bar,

  components: {},

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      data: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          fontSize: '24',
          text: this.$t('ELE0269'),
        },
        layout: {
          padding: {
            top: 6,
            bottom: 6,
            left: 1,
            right: 1,
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                autoSkip: true,
                autoSkipPadding: 0,
                display: true,
                minRotation: 45,
                crossAlign: 'far',
                padding: 5,
              },
              gridLines: {
                drawOnChartArea: true,
                drawTicks: false,
              },
            },
          ],
          yAxes: [
            {
              id: 'line',
              type: 'linear',
              position: 'right',
              display: true,
              ticks: {
                display: true,
                suggestedMin: 0,
                suggestedMax: 100,
                callback: function (tick) {
                  return `${tick}%`
                },
              },
              gridLines: {
                drawOnChartArea: false,
                drawTicks: true,
              },
            },
            {
              id: 'bar',
              type: 'linear',
              position: 'left',
              display: true,
              ticks: {
                display: true,
                suggestedMin: 0,
              },
              gridLines: {
                drawOnChartArea: false,
                drawTicks: true,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return data.tooltips[tooltipItems[0].index]
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    }
  },
  methods: {
    setItems() {
      let data = {
        datasets: [],
        labels: [],
        tooltips: [],
      }

      let line = {
        label: this.$t('ELE0267'),
        order: 1,
        type: 'line',
        fill: false,
        yAxisID: 'line',
        borderColor: '#FB8C00',
        lineTension: 0,
        pointRadius: 3,
        pointBorderColor: '#FB8C00',
        pointBorderWidth: 1.5,
        pointBackgroundColor: '#FB8C00',
        pointHoverRadius: 5,
        pointHoverBorderColor: '#FB8C00',
        pointHoverBorderWidth: 1.5,
        pointHoverBackgroundColor: '#FB8C00',
        pointStyle: 'circle',
        backgroundColor: '#FB8C00',
        data: [],
      }

      let bar = {
        label: this.$t('ELE0268'),
        order: 2,
        yAxisID: 'bar',
        backgroundColor: '#10218B',
        categoryPercentage: 0.2,
        barPercentage: 4,
        data: [],
      }

      for (let i = 0; i < this.items.length; i++) {
        bar.data.push(this.items[i].defectQty)
        line.data.push(this.items[i].accumRatio)
        data.labels.push(this.items[i].defectName)
        data.tooltips.push(this.items[i].defectName)
      }

      data.datasets.push(line, bar)
      this.data = data
    },
    async displayChart() {
      await this.setItems()
      this.renderChart(this.data, this.options)
    },
  },
  mounted() {
    this.displayChart()
  },
  watch: {
    items: {
      handler: function () {
        this.displayChart()
      },
      deep: true,
    },
  },
}
</script>
